export default __webpack_public_path__ + "static/media/export_image.28122a26.png";